import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from '@/components/ui-bridge/core';
import { NavigateBefore, NavigateNext } from '@/components/ui-bridge/icons';
import PropTypes from 'prop-types';

// import classes from './OrderCardServiceModal.module.scss';

const contactMail = 'erik.silva@redevistorias.com.br';

const OrderCardServiceModal = ({ type, isOpen, handleClose }) => {
  const ContentFcAnalise = () => {
    return (
      <>
        <div className="w-full mt-[25px] text-center">
          <img
            src="https://s.vistori.as/assets/banner-modal-fc-analise.png"
            className="img-fluid max-w-[396px] mx-auto"
            style={{ maxHeight: '100px' }}
            alt="FC Análise"
          />
        </div>
        <div>
          <p>
            <FormattedMessage id="orderCardServiceModal.fcAnaliseText1" />
          </p>
          <p>
            <FormattedMessage id="orderCardServiceModal.fcAnaliseText2" />
          </p>
        </div>
        <div className="flex flex-row justify-center">
          <div>
            <img
              src="https://s.vistori.as/assets/img-content-modal-fc-analise-1.png"
              className="img-fluid"
              style={{ maxHeight: '150px' }}
            alt="FC Análise"
            />
          </div>
          <div>
            <img
              src="https://s.vistori.as/assets/img-content-modal-fc-analise-2.png"
              className="img-fluid"
              style={{ maxHeight: '150px', marginBottom: '15px' }}
            alt="FC Análise"
            />
          </div>
        </div>
        <p>
          <FormattedMessage id="orderCardServiceModal.fcAnaliseText3" />
        </p>
        <div className="flex flex-row justify-center">
          <img
            src="https://s.vistori.as/assets/img-content-modal-fc-analise-3.png"
            className="img-fluid"
            style={{ maxHeight: '140px' }}
            alt="FC Análise"
          />
        </div>
        <div>
          <p>
            <FormattedMessage id="orderCardServiceModal.fcAnaliseText4" values={{ email: contactMail }} />
          </p>
        </div>
      </>
    );
  };

  const ContentBry = () => {
    return (
      <>
        <div className="w-full mt-0 text-center">
          <img
            src="https://s.vistori.as/assets/bry-logo.png"
            className="img-fluid max-w-[396px] mx-auto"
            style={{ maxHeight: '200px' }}
            alt="Bry"
          />
        </div>
        <div>
          <p>
            <FormattedMessage id="orderCardServiceModal.bryText1"
              values={{
                strong: chunks => <strong>{chunks}</strong>,
              }} />
          </p>
          <p>
            <FormattedMessage
              id="orderCardServiceModal.bryText2"
              values={{
                strong: chunks => <strong>{chunks}</strong>,
              }}
            />
          </p>
        </div>
        <div className="flex flex-row justify-center">
          <div>
            <img
              src="https://s.vistori.as/assets/img-content-modal-bry-1.png"
              className="img-fluid"
              alt="Bry"
              style={{ maxHeight: '180px' }}
            />
          </div>
        </div>
        <div>
          <p>
            <FormattedMessage id="orderCardServiceModal.bryText3" />
          </p>
          <p>
            <FormattedMessage id="orderCardServiceModal.bryText4" />
          </p>
        </div>
      </>
    );
  };

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={isOpen}
      onClose={handleClose}
      className="flex"
    >
      <div className="bg-white rounded-[4px] m-auto w-[50%] max-[1400px]:w-[60%] max-[1100px]:w-[70%] max-[900px]:w-[80%] max-[670px]:w-[90%]">
        <div className="bg-[#00bbdd] rounded-t-[4px] text-[#2b313c] text-[42px] font-[900] w-full p-[15px] text-center max-[670px]:text-[36px]">
          <div className="uppercase flex items-center justify-center">
            <NavigateBefore className="text-[56px] mt-[-8px]" />
            <NavigateBefore className="text-[56px] mt-[-8px] ml-[-30px]" />
            <NavigateBefore className="text-[56px] mt-[-8px] ml-[-30px]" />
            <FormattedMessage id="orderCardServiceModal.title" />
            <NavigateNext className="text-[56px] mt-[-8px] mr-[-30px]" />
            <NavigateNext className="text-[56px] mt-[-8px] mr-[-30px]" />
            <NavigateNext className="text-[56px] mt-[-8px]" />
          </div>
        </div>
        <div className="flex flex-col px-6 max-[670px]:text-[13px]">
          {type === 'marketplace_fichacerta' ? (
            <ContentFcAnalise />
          ) : type === 'marketplace_bry' ? (
            <ContentBry />
          ) : null}
          <div className="flex mx-auto pb-2.5">
            <img
              src="https://s.vistori.as/assets/img-footer-modal-rvtech.png"
              className="img-fluid"
              alt="RVTech Footer"
            />
          </div>
        </div>
        <div className="bg-[#2b313c] rounded-bl-[4px] rounded-br-[4px] h-[37px] mt-2.5"></div>
      </div>
    </Modal>
  );
};

OrderCardServiceModal.propTypes = {
  type: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default OrderCardServiceModal;
